if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);       
        const qty = opener.getAttribute('data-qty');
        const selectedVar = opener.getAttribute('data-variant-id');
        const selectedVarTitle = opener.getAttribute('data-selected-title');
        const line = opener.getAttribute('data-line-index');
        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');            
            this.productElement = responseHTML.querySelector('section[id^="CartProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            
            this.modalContent.querySelectorAll('fieldset.product-form__input').forEach(inputWrapper => {
              const dataId = $(inputWrapper).data('id');                
              const radioInputs = inputWrapper.querySelectorAll('input[type="radio"]');
                radioInputs.forEach(radioInput => {
                  if (radioInput.classList.contains('active__radio')) { 
                    radioInput.checked = true;
                    radioInput.dispatchEvent(new Event('change'));
                    const selectElements = Array.from(this.modalContent.querySelectorAll('.select.custm_drpdwn'));
                    const $select = selectElements.filter(function(selectElement) {
                      const container = $(selectElement).find('.size-list-container');
                      const dataIdFromContainer = container.data('id');                                                        
                      return dataIdFromContainer === dataId;                      
                    })[0];        

                    if ($select) {              
                      const $selectElement = $($select);                      
                      const $colorSwatchContainer = $selectElement.hasClass('color-swatch-container') ? $selectElement : null;              
                        if ($colorSwatchContainer) {                            
                         const $dropdownItem = $colorSwatchContainer.find('.dropdown-item span[data-selected="selected"]');                        
                          if ($dropdownItem.length) {                         
                            const $colorValueSpan = $dropdownItem.find('.color_value');
                            if ($colorValueSpan.length) {                      
                              const colorValueStyle = $colorValueSpan.attr('style');     
                              // $colorSwatchContainer.find('.selected-option-style').show();
                              $colorSwatchContainer.find('.selected-option-style').attr('style', colorValueStyle);       
                              
                            } 
                          }                         
                          $selectElement.find('.selected-option').text(radioInput.value);
                        }
                      else {   
                        $selectElement.find('.selected-option').html(radioInput.value);                     
                      }                                     
                    } else {
                        // console.log("No matching .select found for data-id:", dataId);
                    }
                  }
                });
              });                                   
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
            
              const qtyDropdownContainer = this.modalContent.querySelector('.quantity-dropdown__container');
              const qtyDropdownButton = qtyDropdownContainer.querySelector('.quantity-dropdown__button');
              const qtyDropdownList = qtyDropdownContainer.querySelector('.quantity-dropdown__list');
              const qtyHiddenInput = qtyDropdownContainer.querySelector('input[name="quantity"]');             
              if (qtyDropdownList && qtyHiddenInput) {
                const selectedQtyItem = qtyDropdownList.querySelector(`li[data-value="${qty}"]`);
                if (selectedQtyItem) {                 
                  qtyDropdownList.querySelectorAll('li').forEach(item => item.classList.remove('selected'));
                  selectedQtyItem.classList.add('selected');
                  qtyDropdownButton.querySelector('.selected-quantity').textContent = qty;                   
                  qtyHiddenInput.value = qty;                 
                  qtyHiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }           
            initializeDropdowns(qtyHiddenInput.value, line, selectedVar);
            
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;
    
        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
function initializeDropdowns(qty, lineIndex, vId) {
  $('.size-drpdwn-toggle.button').each(function() {
    const $customButton = $(this);
    const pickerType = $customButton.attr('data-picker');
    handleDropdown($customButton, pickerType);
  });

  $(document).on('click', function(event) {
    $('.size-list-container').each(function() {
      const $dropdown = $(this);
      const $customButton = $dropdown.closest('.select').find('.size-drpdwn-toggle.button');
      if (!$customButton.is(event.target) && $customButton.has(event.target).length === 0 && !$dropdown.is(event.target) && $dropdown.has(event.target).length === 0) {
        $dropdown.removeClass('show');
        $dropdown.parent().removeClass('show');
      }
    });     
  });  
  const oldVarId = vId;
  document.querySelector('.update-cart-product-global').addEventListener('click', function(e) {
    e.preventDefault();     
    const $quantityContainer = $(this).closest('.product-color-size-container');    
    const qty = $quantityContainer.find('input[name="quantity"]').val();   
    const newId = $(this).closest('.product__info-wrapper').find('input[name="id"]').val();
    modifyLineItem(qty, lineIndex, newId, oldVarId);
  });
}
  function handleDropdown($customButton, pickerType) {
    if ($customButton.length) {
      $customButton.on('click', function() {      
        const dropdownID = $customButton.closest('.select').find('.size-list-container').attr('data-id');
        const $dropdown = $customButton.closest('.select').find(`.size-list-container[data-id="${dropdownID}"]`);    
        const $dropdownItems = $dropdown.find('li span');
        const $fieldset = $('fieldset[data-id="'+dropdownID+'"]');
        const $realDropdown = $('#' + dropdownID);
        
        $dropdown.parent().toggleClass('show');   
        $dropdown.toggleClass('show');
        if ($dropdown.hasClass('show')) {               
           $dropdownItems.on('click', function(event) {
              handleDropdownItemClick(event, $dropdown, $dropdownItems, $customButton, pickerType, $fieldset, $realDropdown);
           });                  
        } else {       
          $dropdownItems.off('click', handleDropdownItemClick);
        }
      });
    } else {
      // console.log('Custom button not found');
    }
    function handleDropdownItemClick(event, $dropdown, $dropdownItems, $customButton, pickerType, $fieldset, $realDropdown) {
      const $targetItem = $(event.target).closest('li');
      if ($targetItem.hasClass('unavailable')) {
        return;
      }
      $dropdownItems.closest('li').removeClass('selected');
      $targetItem.addClass('selected');
      const selectedText = $(event.target).text();
      const selectedValue = $(event.target).data('value');
      $customButton.find('.selected-option').text(selectedValue);       

      const $selectedOptionStyle = $customButton.find('.selected-option-style');
      if ($selectedOptionStyle.length) {
        const $colorValueSpan = $targetItem.find('.color_value');
        if ($colorValueSpan.length) {
          const colorValueStyle = $colorValueSpan.attr('style');
          $selectedOptionStyle.attr('style', colorValueStyle);
          $selectedOptionStyle.show();
        }
      }

      if (pickerType === 'button') {
        const $radioButton = $fieldset.find('input[type="radio"][value="' + selectedValue + '"]');
        if ($radioButton.length) {
          $radioButton.prop('checked', true);        
          const changeEvent = new Event('change', { bubbles: true });
          $radioButton[0].dispatchEvent(changeEvent);
        }
      }
      else {
        $realDropdown.val(selectedValue);
        $realDropdown[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
      $dropdown.removeClass('show');
      $dropdown.parent().removeClass('show');
      $dropdownItems.off('click');              
    }
  }
$(document).ready(function() {
   $('body').on('click', '.quantity-dropdown__button', function() {
    $(this).next('.quantity-dropdown__list').toggleClass('show');
  });

  $('body').on('click', '.quantity-dropdown__list li', function() {
    const selectedValue = $(this).data('value');
    const $dropdownContainer = $(this).closest('.quantity-dropdown__container');
  
    $dropdownContainer.find('.selected-quantity').text(selectedValue);   
    $dropdownContainer.find('input[name="quantity"]').val(selectedValue);
    $dropdownContainer.find('.quantity-dropdown__list').removeClass('show');          
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.quantity-dropdown__container').length) {
      $('.quantity-dropdown__list').removeClass('show');
    }
  }); 
});

function extraProductInfo(varId) { 
  const input = document.querySelector('input.product-variant-id[name="id"]');
  input.value = varId;
  input.dispatchEvent(new Event('change', { bubbles: true }));
   const variantSpan = document.querySelector(`span[id="${varId}"]`);
  const maxQty = variantSpan ? parseInt(variantSpan.dataset.qty, 10) : 0;
  const quantityDropdown = document.querySelector('.quantity-dropdown__list');
  let currentSelectedValue = parseInt(quantityDropdown.querySelector('li.selected')?.getAttribute('data-value'), 10);
  const quantityInput = quantityDropdown.closest('.quantity-dropdown__container').querySelector('input[name="quantity"]');
  
  const itemCount = maxQty > 5 ? 5 : maxQty;
  
  quantityDropdown.innerHTML = '';
  
   for (let i = 1; i <= itemCount; i++) {
        const li = document.createElement('li');
        li.setAttribute('data-value', i);
        li.innerHTML = `<span>${i}</span>`;
       if (i === currentSelectedValue) {
            li.classList.add('selected');
        }
        quantityDropdown.appendChild(li);
    }

    if (currentSelectedValue > maxQty) {
        currentSelectedValue = maxQty;
        document.querySelector('.selected-quantity').textContent = maxQty;
        quantityInput.value = maxQty;
        quantityDropdown.querySelectorAll('li').forEach(li => li.classList.remove('selected')); // Remove selected class from all
        quantityDropdown.querySelector(`li[data-value="${maxQty}"]`).classList.add('selected');
    }

    quantityDropdown.setAttribute('data-max', maxQty);
}
function modifyLineItem(qty, lineIndex, newVariantId, oldVarId) {
    const quantity = qty;
    const line = lineIndex;
    const variantId = newVariantId;  
    const oldVariantId = oldVarId;   
    const cartItemsElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');  
    const itemId = document.querySelector(`#CartItem-${lineIndex}`)?.dataset.itemId;
    const quickAddModal = document.querySelector(`#QuickAdd-${itemId}`);
    const modalCloseButton = document.querySelector(`#ModalClose-${itemId}`);

    if (cartItemsElement) {
        if (newVariantId === oldVariantId) {
            // cartItemsElement.updateQuantity(line, quantity, 'quantity', newVariantId)
            //     .then(() => {                                    
            //         if (quickAddModal && modalCloseButton) {
            //             modalCloseButton.click();
            //         }                 
            //     })
            //     .catch(error => {
            //         console.error('Error updating quantity:', error);
            //     });
            try {
              cartItemsElement.updateQuantity(line, quantity, 'quantity', newVariantId);
              if (quickAddModal && modalCloseButton) {
                setTimeout(() => {
                    modalCloseButton.click();
                }, 800); // ad
              }
            } 
            catch (error) {
              console.error("Error updating quantity:", error);
            }
        } else {
            // Add the new variant and refresh cart UI
            $.ajax({
                url: '/cart/add.js',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    id: variantId,
                    quantity: quantity
                }),
                dataType: 'json'
            })
            .then(response => {
                // console.log('New variant added successfully:', response);
                updateCartCount(response);
                // return cartItemsElement.onCartUpdate();
              return fetch(`${routes.cart_url}?section_id=main-cart-items`);
            })
            .then(response => response.text())
            .then(responseText => {               
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const updatedCartHtml = html.querySelector('cart-items') || html.querySelector('cart-drawer-items');
                if (updatedCartHtml) {
                    cartItemsElement.innerHTML = updatedCartHtml.innerHTML;
                } else {
                    console.error('Failed to find updated cart HTML.');
                }                
                return findLineItemByVariantId(oldVariantId);
            })
            .then(oldLineItem => {
                if (oldLineItem) {                   
                    return cartItemsElement.updateQuantity(oldLineItem.line, 0, 'quantity', oldVariantId);
                } else {
                    console.warn('Old variant not found in the cart.');
                }
            })
            .then(() => {               
                if (quickAddModal && modalCloseButton) {
                    modalCloseButton.click();
                }
            })
            .catch(error => {
                console.error('Error updating or removing variant:', error);
            });
        }
    }
}

function findLineItemByVariantId(variantId) {
    return fetch(`${routes.cart_url}?section_id=main-cart-items`)
    .then(response => response.text())
    .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const lineItemElement = html.querySelector(`[data-variant-id="${variantId}"]`);
        if (lineItemElement) {
            return {
                line: parseInt(lineItemElement.dataset.line, 10)
            };
        }
        return null;
    })
    .catch(e => {
        console.error(e);
    });
}
function updateCartCount(cartData) {
  try {
      setTimeout(function () {
        $.getJSON('/cart.json').then(cart => {
            fetch('/cart?view=item').then(response => response.text())
            .then(text => {
                const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                const cartFormInnerHTML = sectionInnerHTML.getElementById('CartDrawer').innerHTML;              
                const totalPrice = sectionInnerHTML.querySelector('#CartDrawer .totals__total-value');               
                if (totalPrice) {              
                  // $('#main-cart-footer .totals__total-value').html(totalPrice.innerHTML);
                  $('.sticky_cart_total').html(totalPrice.innerHTML);
                }
                $('#CartDrawer').html(cartFormInnerHTML)               
                $('cart-drawer').removeClass('is-empty')
                $('cart-drawer-items').removeClass('is-empty')
              if($('#cart-icon-bubble .cart-count-bubble').length===0){
                const cartNumber=document.createElement('div')
                cartNumber.className='cart-count-bubble'
                cartNumber.innerHTML=`
                <span aria-hidden="true">${cart.item_count}</span>
                <span class="visually-hidden">${cart.item_count} items</span>
                `
                $('#cart-icon-bubble').append(cartNumber)
              }else{
                 $('.cart-count-bubble span[aria-hidden="true"]').each((_,count)=>$(count).text(cart.item_count))
              }              
            })
        });
      }, 1500);
    } catch (e) {
      console.warn(e);
    }
}